<template>
<div>
	<div>
		<div class="col-lg-12">
			<h2 class="page-header">
				<span id="page-header">{{ pageHeader }}</span>
				<a href="/areas/" class="hidden-md hidden-lg"><button class="btn btn-success">Zur Liste</button></a>
			</h2>

			<div class="row">
				<h3 class="col-lg-12">Allgemeine Informationen <router-link class="btn btn-primary create-new pull-right" to="/areas/new"><i class="fa fa-plus"></i></router-link></h3>
				<div class="form-horizontal" id="customer-information">

					<div class="row">
						<div class="col-lg-6">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="firstname">Name <span style="color: #f00; font-weight: 800">*</span></label>
								<div class="col-sm-12">
									<input name="firstname" id="firstname" class="form-control" v-model="model.model.name" required>
								</div>
							</custom-input>
						</div>

						<div class="col-lg-6">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="graveyard">Friedhof <span style="color: #f00; font-weight: 800">*</span></label>
								<div class="col-sm-12">
									<div class="input-group">
										<input id="graveyard" name="graveyard" class="form-control" required="required" v-model="model.model.graveyard_name" readonly="readonly">
										<span class="input-group-addon addon-primary" @click="selectGraveyard()"><i class="fa fa-pencil"></i></span>
									</div>
								</div>
							</custom-input>
						</div>
					</div>

					<div class="row">
						<div class="col-lg-4">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="coordinates">Koordinaten</label>
								<div class="col-sm-12">
									<div :class="coordinatesClass">
										<input id="coordinates" name="coordinates" class="form-control" type="text" v-model="model.model.coordinates">
										<a class="input-group-addon" target="_blank" :href="googleURL" v-if="googleURL !== null">Maps</a>
									</div>
								</div>
							</custom-input>
						</div>

						<div class="col-lg-4">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="category">Kategorie <span style="color: #f00; font-weight: 800">*</span></label>
								<div class="col-sm-12">
									<div class="input-group">
										<input id="category" name="category" class="form-control" required="required" v-model="model.model.category_name" readonly="readonly">
										<span class="input-group-addon addon-primary" @click="selectCat()"><i class="fa fa-pencil"></i></span>
									</div>
								</div>
							</custom-input>
						</div>

						<div class="col-lg-4">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="price">Preis (Kategorie: {{ model.model.category_price }} &euro;)</label>
								<div class="col-sm-12">
									<input name="price" id="price" class="form-control" required="required" v-model="model.model.price" type="number">
								</div>
							</custom-input>
						</div>
					</div>

					<custom-input inline>
						<label class="col-sm-12 control-label" for="booked">Beschreibung</label>
						<div class="col-sm-12">
							<input name="booked" id="booked" class="form-control" required="required" v-model="model.model.description">
						</div>
					</custom-input>

					<div class="row">
						<div class="form-group">
							<div class="col-lg-12 text-center">
								<a href="/areas/" class="hidden-sm hidden-xs"><button class="btn btn-success">Zur Liste</button></a>
								<button class="btn btn-primary" @click="saveArea()">Speichern</button>
							</div>
						</div>
					</div>

					<div class="row">
						<div class="col-lg-12">
							<div class="col-lg-12">
								<map-marker :center="geoLocation" :info="pInfo"></map-marker>
							</div>
						</div>
					</div>

					<div class="row" v-show="model.model.id > 0">
						<div class="col-lg-12">
							<div class="col-lg-12">
								<ul class="nav nav-tabs responsive-tabs">
									<li class="active"><a href="#addresses">Grabstätten</a></li>
								</ul>

								<div class="tab-content col-lg-12">
									<div class="tab-pane active" id="addresses">
										<custom-table :cols="graveCols" :src-model="model.graves" add delete nosort select="/graves/{:id}" @add="addRelation('graves')" @edit="editGrave" @delete="deleteGrave" :default-sort="defSort"></custom-table>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>

		<!-- Grab -->
		<custom-modal v-if="visibleModal === 'addgraves'" :title="addGraveMode === 'new' ? 'Grab anlegen' : 'Grab hinzufügen'" @cancel="visibleModal = ''" @ok="newGrave()" ok-style="btn btn-primary" :ok-text="addGraveMode === 'new' ? 'Speichern' : null">
			<div class="row">
				<div class="col-lg-12">
					<button class="btn btn-default btn-sm" @click="addGraveMode = 'relation'">Hinzufügen</button>
					<button class="btn btn-default btn-sm" @click="addGraveMode = 'new'">Anlegen</button>
				</div>
			</div>

			<div class="row">
				<div class="col-lg-12">
					<custom-table v-if="addGraveMode === 'relation'" row-add @rowAdd="saveGrave" :src-model="$store.getters.models('graves')" :cols="graveSearchCols" store="graves" search :default-sort="defSort"></custom-table>

					<div v-if="addGraveMode === 'new'">
						<custom-input>
							<label class="col-sm-12 control-label" for="type">Art</label>
							<div class="col-sm-12">
								<select id="type" v-model="graves.model.type_id" class="form-control">
									<option value="0">[Nicht spezifiziert]</option>
									<option v-for="gtype in $store.getters.models('grave_types')" :value="gtype.id">{{ gtype.name }}</option>
								</select>
							</div>
						</custom-input>

						<custom-input inline>
							<label class="col-sm-12 control-label" for="firstname">Name</label>
							<div class="col-sm-12">
								<input name="firstname" class="form-control" v-model="graves.model.name" required>
							</div>
						</custom-input>

						<custom-input inline>
							<label class="col-sm-12 control-label" for="description">Beschreibung</label>
							<div class="col-sm-12">
								<input name="description" id="description" class="form-control" v-model="graves.model.description" required>
							</div>
						</custom-input>

						<custom-input inline>
							<label class="col-sm-12 control-label" for="price">Preis</label>
							<div class="col-sm-12">
								<input name="price" id="price" class="form-control" v-model="graves.model.price" required>
							</div>
						</custom-input>
					</div>
				</div>
			</div>
		</custom-modal>

		<!-- Kategorie -->
		<custom-modal v-if="visibleModal === 'selectcategories'" title="Kategorie auswählen" @cancel="visibleModal = ''">
			<div class="row">
				<div class="col-lg-12">
					<custom-table row-add @rowAdd="pickCat" :src-model="$store.getters.models('categories')" :cols="catSearchCols" store="categories" search :default-sort="defSort"></custom-table>
				</div>
			</div>
		</custom-modal>

		<!-- Friedhof -->
		<custom-modal v-if="visibleModal === 'selectgraveyard'" title="Friedhof auswählen" @cancel="visibleModal = ''">
			<div class="row">
				<div class="col-lg-12">
					<custom-table select @select="pickGraveyard" :src-model="$store.getters.models('graveyards')" :cols="[ {name: 'Name', json: 'name', type: 'text'} ]" store="categories" search :default-sort="defSort"></custom-table>
				</div>
			</div>
		</custom-modal>

		<!-- <custom-modal v-if="visibleModal === 'addgraves'" title="Grabstätte hinzufügen" cancel-text="Abbrechen" cancel-style="btn btn-default" @cancel="visibleModal = ''">
			<custom-table row-add @rowAdd="saveGrave" :src-model="$store.getters.models('graves')" :cols="graveSearchCols" store="graves" search :default-sort="defSort"></custom-table>
		</custom-modal> -->

		<custom-modal title="Grab entfernen" v-if="visibleModal === 'deletegraves'" ok-text="Löschen" cancel-text="Abbrechen" @ok="confirmDeleteRelation('graves')" @cancel="visibleModal = ''" ok-style="btn btn-danger">
			<strong>Sind Sie sicher, dass Sie das Grab entfernen möchten?</strong>
		</custom-modal>

		<!-- Fehlermeldungen -->
		<custom-modal v-if="visibleModal === 'errSavingModel'" @ok="visibleModal = ''" ok-text="OK" @cancel="visibleModal = ''">
			Fehler beim Speichern des Kunden.
		</custom-modal>
	</div>
</div>

</template>

<script>
import CustomTable from 'components/custom-table.vue'
import CustomModal from 'components/custom-modal-old.vue'
import CustomInput from 'components/custom-input.vue'
import MapMarker from 'components/map-marker.vue'

import Datepicker from 'vuejs-datepicker'

import CustomersModel from 'models/customers.js'
import GravesModel from 'models/graves.js'
import AreasModel from 'models/areas.js'

import modelTools from 'functions/models.js'
import relationTools from 'functions/relations.js'
import graveTools from 'functions/grave.js'

import store from 'root/store.js'
import { authCheck } from 'functions/auth_check.js'

import { calcGeoLocation } from "root/tools.js"

export default {
	beforeRouteEnter (to, from, next) {
		const route = authCheck('areas')
		if (route === null) {
			next()
		} else {
			next(route)
		}
	},

	beforeRouteLeave (to, from, next) {
		console.log("LEAVEN")

		if (to.path === '/'+this.model.name+'/new') {
			this.model.clear()
		}
		next()
	},

	// Normale Eigenschaften
	data () {
		return {
			model: AreasModel,
			graves: GravesModel,

			// visibleModal: 'addgraves'
			visibleModal: '',
			addGraveMode: 'relation',
			selectCategoryMode: 'relation',

			graveCols: [
				{
					name: "Name",
					json: "name",
					type: "text"
				},
				{
					name: 'Kunden',
					json: 'customer_count',
					type: 'int',
					css: {
						default: 'btn btn-danger',
						0: 'btn btn-success'
					}
				},
				{
					name: 'Verstorbene',
					json: 'deceased_count',
					type: 'int',
					css: {
						default: 'btn btn-danger',
						0: 'btn btn-success'
					}
				}
			],

			graveSearchCols: [
				{
					name: 'Name',
					json: 'name',
					type: 'text'
				},
				{
					name: 'Fläche',
					json: 'area_name',
					type: 'text'
				}
			],

			catSearchCols: [
				{
					name: 'Name',
					json: 'name',
					type: 'text'
				},
				{
					name: 'Preis',
					json: 'price',
					type: 'float'
				}
			],

			defSort: {col: 'id', order: 'asc'}
		}
	},

	activated () {
		console.log("ACTIVATED")

		this.model.clear()
		this.model.model.id = parseInt(this.$route.params.id)
		if (isNaN(this.model.model.id)) {
			this.model.model.id = 0
		}

		this.$store.dispatch('loadModel', 'grave_types')

		// this.$refs.mymap.resizePreserveCenter()

		this.$store.dispatch('loadModel', 'areas')
		.then(result => {
			var model = this.$store.getters.model('areas', this.model.model.id)
			this.model.copy(model)
			this.model.model.name = model.name

			this.$store.dispatch('loadRelation', {basis: this.model, relation: 'graves'})
			.then(data => this.initRelation('graves', data))
			.catch(e => {
				if (e.status === 401) {
					this.$router.replace('/logout/')
				}
			})

			this.$store.dispatch('loadModels', this.model.relations)

			$('.responsive-tabs').responsiveTabs({
				accordionOn: ['xs', 'sm'] // xs, sm, md, lg
			})
		})
		.catch(err => {
			if (e.status === 401) {
				this.$router.replace('/logout/')
			}
		})
	},

	computed: {
		pageHeader () {
			let model
			let name

			if (this.model.model.id === 0) {
				return 'Neue Fläche anlegen'
			} else {
				model = this.$store.getters.model('areas', this.model.model.id)
				name = model.name

				return 'Fläche "' + name.trim() + '" verwalten'
			}
		},

		catName () {
			let cat

			cat = this.$store.getters.model('categories', this.model.model.category_id)
			return cat.name
		},

		googleURL () {
			return typeof this.model.model.coordinates === 'string' && this.model.model.coordinates.trim() !== "" ? 'https://www.google.de/maps/?q=' + this.model.model.coordinates.split(' ').join('%20').split('.').join('%2E').split(',').join('%2C') : null
		},

		coordinatesClass () {
			return this.googleURL === null ? null : 'input-group'
		},

		geoLocation () {
			return this.model.model.coordinates
		},

		pInfo () {
			return {
				options: {
					pixelOffset: {
						width: 0,
						height: 0
					}
				},
				coordinates: this.calcGeoLocation(this.model.model.coordinates),
				opened: true,
				content: this.model.model.name
			}
		}
	},

	components: {
		CustomTable,
		CustomModal,
		CustomInput,
		MapMarker,
		Datepicker
	},

	methods: {
		calcGeoLocation: calcGeoLocation,

		calcIcon (aArea) {
			// var SuffixIndex = ["[Vergeben]", "[Teilbelegt]", "[Frei]", "[Keine Gräber]"].indexOf(aArea.status)
			/* return {
				"url": "/img/icons/black_blue.svg",
				"size":  new google.maps.Size(25, 25),
				"scaledSize": new google.maps.Size(25, 25)
			} */
			//return "https://dev.w3.org/SVG/tools/svgweb/samples/svg-files/android.svg"
			let name = aArea.name
			switch (aArea.short_name) {
				case "BEE":
					return {
						"url": "/img/icon_blau.png",
						"scaledSize": new google.maps.Size(20, 20)
					}

				case "BAG":
					return {
						"url": "/img/icon_weis.png",
						"scaledSize": new google.maps.Size(20, 20)
					}

				case "BBG":
					return {
						"url": "/img/icon_weis.png",
						"scaledSize": new google.maps.Size(20, 20)
					}

				case "BEG":
					return {
						"url": "/img/icon_weis.png",
						"scaledSize": new google.maps.Size(20, 20)
					}

				case "BFG":
					return {
						"url": "/img/icon_weis.png",
						"scaledSize": new google.maps.Size(20, 20)
					}

				default:
					return {
						"url": "/img/icon_gruen.png",
						"scaledSize": new google.maps.Size(20, 20)
					}
			}
		},

		// Tools des Models
		saveModel: modelTools.save,

		// Beziehungen zwischen Models
		initRelation: relationTools.init,
		editRelation: relationTools.edit,
		deleteRelation: relationTools.delete,
		addRelation: relationTools.add,
		saveRelation: relationTools.save,
		confirmDeleteRelation: relationTools.confirmDelete,

		// Grab speziefische Methoden
		editGrave: graveTools.edit,
		deleteGrave: graveTools.delete,

		selectGraveType () {
			this.visibleModal = 'selectGraveType'
		},

		clearGraveType () {
			this.model.model.type_id = 0
			this.model.model.type_name = ''
		},

		pickGraveType (aModel) {
			this.model.model.type_id = aModel.id
			this.model.model.type_name = aModel.name
			this.visibleModal = ''

			if (this.model.model.name === '') {
				let CountType = this.$store.getters.models('graves').filter(Value => Value.type_id === aModel.id).length + 1
				this.model.model.name = aModel.name + ' ' + CountType
			}
		},

		selectCat () {
			this.visibleModal = 'selectcategories'
		},

		selectGraveyard () {
			this.visibleModal = 'selectgraveyard'
		},

		pickCat (aModel) {
			this.model.model.category_id = aModel.id
			this.model.model.category_name = aModel.name
			this.visibleModal = ''
		},

		pickGraveyard (aModel) {
			this.model.model.graveyard_id = aModel.id
			this.model.model.graveyard_name = aModel.name
			this.visibleModal = ''
		},

		newCat () {
			this.saveModel(this.categories, true)
			.then(response => {
				// console.log(response);
				this.pickCat(response)
			})
			.catch(err => {
				// console.log(err)
			})
		},

		saveGrave (aModel) {
			this.graves.model.name = aModel.id + ': Dummy'
			this.graves.model.id = 0
			this.saveRelation('graves')
			this.visibleModal = ''
		},

		updateGrave () {
			this.graves.model.name = this.graves.model.grave_id + ': Dummy'
			this.saveRelation('graves')
			this.visibleModal = ''
		},

		saveArea () {
			this.saveModel()
			.then(id => {
				this.model.model.id = id
				this.$router.replace("/areas/" + id)
			})
			.catch(id => {
				this.model.model.id = id
			})
		},

		newGrave () {
			this.saveModel(this.graves)
			.then(response => {
				this.graves.model.name = response + ': Dummy'
				this.graves.model.customer_id = response
				this.graves.model.id = 0
				this.saveRelation('graves')
			})
			.catch(err => {
				// console.log(err)
			})
		},

		getTitle (aArea) {
			return this.model.model.id === aArea.id ? aArea.name : ""
		}
	},

	filters: {
	}
}
</script>

<style>
.vue-map-container {
	width: 100%;
	height: 500px;
}
</style>



// WEBPACK FOOTER //
// AreaEdit.vue?73b51276